import { render, staticRenderFns } from "./SignatarioNovoDocumento.vue?vue&type=template&id=3f3fae5e"
import script from "./SignatarioNovoDocumento.vue?vue&type=script&lang=js"
export * from "./SignatarioNovoDocumento.vue?vue&type=script&lang=js"
import style0 from "./SignatarioNovoDocumento.vue?vue&type=style&index=0&id=3f3fae5e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports